import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Prerendered marketing pages ship their full HTML inside #root plus a
// data-prerender-path stamp (see scripts/prerender.js). Hydrate over it only
// when the stamp matches the current URL; SPA-fallback serves the homepage
// file for unknown routes (e.g. /dashboard), where hydrating would mismatch,
// so clear the stale markup and mount fresh instead.
const normalizePath = (p) => (p.length > 1 && p.endsWith("/") ? p.slice(0, -1) : p);
const prerenderPath = container.getAttribute("data-prerender-path");
const matchesRoute =
  prerenderPath && normalizePath(window.location.pathname) === normalizePath(prerenderPath);

if (container.firstElementChild && matchesRoute) {
  ReactDOM.hydrateRoot(container, app);
} else {
  if (container.firstElementChild) container.innerHTML = "";
  ReactDOM.createRoot(container).render(app);
}
